import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorsState } from './types';

const initialState: ErrorsState = {
  errors: [],
};

const errorsSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    registerError: (state, action: PayloadAction<Error>) => {
      state.errors = [...state.errors, action.payload];
    },
    clearErrors: () => initialState,
  },
});

export const {
  actions: { registerError, clearErrors },
  reducer: errorsSliceReducer,
} = errorsSlice;
